import {Component, ElementRef, HostBinding, Input, SimpleChanges, ViewChild} from '@angular/core';


@Component({
  selector: 'wm-magnifer-glass',
  templateUrl: './magnifer-glass.component.html',
  styleUrls: ['./magnifer-glass.component.less']
})
export class MagniferGlassComponent {
    @ViewChild('magnifier') magnifierViewChild: ElementRef;
    magnifier: HTMLCanvasElement;
    img: HTMLImageElement;

    @Input() x: number;
    @Input() y: number;
    @Input() dx: number;
    @Input() dy: number;
    @Input() containerWidth: number;
    @Input() containerHeight: number;

    @Input()
    isVisible: boolean;

    @HostBinding('style.left.px')
    magX: number;

    @HostBinding('style.top.px')
    magY: number;

    @Input()
    imageUrl: string;

    imgWidth: number;
    imgHeight: number;

    backgroundSize: string;
    backgroundPosition: string;

    @HostBinding('style.width.px')
    @HostBinding('style.height.px')
    magnifierSize = 250;

    @HostBinding('style.border-width.px')
    magnifierBorderSize = 2;

    zoom = 2.5;
    canDisplay: boolean = false;

    ngAfterViewInit() {
        this.magnifier = this.magnifierViewChild.nativeElement;
    }

    ngOnChanges(changes: SimpleChanges) {
        this.magX = this.x - (this.magnifierSize / 2);
        this.magY = this.y - (this.magnifierSize / 2);

        if ('imageUrl' in changes && this.imageUrl) {
            this.imgWidth = this.containerWidth * this.zoom;
            this.imgHeight = this.containerHeight * this.zoom;
            this.backgroundSize = `${this.imgWidth}px ${this.imgHeight}px`;
            this.canDisplay = true;
        }
        if (this.shouldDisplay()) {
            this.backgroundPosition = `${-this.dx * this.imgWidth + this.magnifierSize/2 - this.magnifierBorderSize}px ${-this.dy * this.imgHeight + this.magnifierSize/2 - this.magnifierBorderSize}px`;
        }
    }

    shouldDisplay(): boolean {
        return this.canDisplay && this.isVisible;
    }
}
